module.exports = __webpack_public_path__ + "static/media/employee.31e09ff6.svg";